import CustomLink from '../../../components/shared/custom-link';
import Button from '../../../components/shared/custom-btn';
import CustomInput from '../../../components/shared/custom-input';
import React, { useState } from 'react';
import { countryCodes } from '../../../data/index';
import { formatPhoneNumber } from '../../../utils/format-phone-utils';


const Form = ({ handleSubmit, formData, handleChange, errors, isSubmitting, successMessage }) => {
    const [termsAccepted, setTermsAccepted] = useState(false);
    const [countryCode, setCountryCode] = useState('+1');
    const [localPhoneNumber, setLocalPhoneNumber] = useState('');

    const handlePhoneChange = (e) => {
        const rawValue = e.target.value;
        const formatted = formatPhoneNumber(rawValue, countryCode);
        setLocalPhoneNumber(formatted);

        // Combine country code with digits only when saving to formData
        const digitsOnly = rawValue.replace(/\D/g, '');
        handleChange({ target: { name: 'msisdn', value: `${countryCode}${digitsOnly}` } });
    };

    const handleCountryCodeChange = (e) => {
        const newCode = e.target.value;
        setCountryCode(newCode);

        // Update the form data with new country code
        const digitsOnly = localPhoneNumber.replace(/\D/g, '');
        handleChange({ target: { name: 'msisdn', value: `${newCode}${digitsOnly}` } });
    };


    return (
        <form onSubmit={handleSubmit} className='space-y-3'>
            <div className='grid xs:grid-cols-2 grid-cols-1 lg:gap-3 gap-2'>
                <CustomInput
                    label="First Name"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    inputStyle="border border-border !py-2 !text-sm bg-white rounded-lg"
                    placeholder="John"
                    labelStyle="text-sm"
                    error={errors.firstName}
                />
                <CustomInput
                    label="Last Name"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    inputStyle="border border-border !text-sm !py-2 bg-white rounded-lg"
                    placeholder="Doe"
                    labelStyle="text-sm"
                    error={errors.lastName}
                />
            </div>

            <CustomInput
                label={<span>Work Email Address <span className='text-xs text-gray-400'>(verification code sent here)</span></span>}
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                inputStyle="border border-border !text-sm !py-2 bg-white rounded-lg"
                placeholder="your@email.com"
                labelStyle="text-sm"
                error={errors.email}
            />

            <div className='flex items-center gap-3'>
                <div className='flex flex-col gap-0.5 w-fit'>
                    <label htmlFor="countryCode" className='whitespace-nowrap text-sm'>Country Code</label>
                    <select
                        name="countryCode"
                        value={countryCode}
                        onChange={handleCountryCodeChange}
                        className='h-full xs:w-32 outline-none w-24  !text-sm py-[3px] px-4 border-2 border-border bg-white rounded-xl'
                    >
                        {countryCodes.map(({ code, name }) => (
                            <option key={`${code}-${name}`} value={code}>{`${code} (${name})`}</option>
                        ))}
                    </select>
                </div>
                <div className='flex-grow w-full'>
                    <CustomInput
                        label="Phone Number"
                        name="msisdn"
                        type="tel"
                        value={localPhoneNumber}
                        onChange={handlePhoneChange}
                        inputStyle="border border-border !text-sm !py-2 bg-white rounded-lg"
                        placeholder="e.g. 123-456-7890"
                        labelStyle="text-sm"
                        error={errors.msisdn}
                    />
                </div>
            </div>


            <CustomInput
                label="Password"
                name="password"
                type="password"
                value={formData.password}
                onChange={handleChange}
                inputStyle="border border-border !text-sm !py-2 bg-white rounded-lg"
                placeholder="••••••••"
                labelStyle="text-sm"
                error={errors.password}
            />

            <CustomInput
                label="Confirm Password"
                name="confirmPassword"
                type="password"
                value={formData.confirmPassword}
                onChange={handleChange}
                inputStyle="border border-border !text-sm !py-2 bg-white rounded-lg"
                labelStyle="text-sm"
                placeholder="••••••••"
                error={errors.confirmPassword}
            />

            <div className='flex items-center gap-2'>
                <input
                    type="checkbox"
                    className='h-4 w-4'
                    name="terms"
                    id="terms"
                    checked={termsAccepted}
                    onChange={(e) => setTermsAccepted(e.target.checked)}
                />
                <p className='text-sm'>I agree to the <CustomLink to='https://yogps.com/terms-and-conditions' target={'_blank'} className={'text-blue-500 hover:underline ml-0.5'}>Terms & Conditions</CustomLink> and <CustomLink to='https://yogps.com/privacy-policy/' target={'_blank'} className={'text-blue-500 hover:underline ml-0.5'}>Privacy Policy</CustomLink></p>
            </div>

            <Button
                type="submit"
                label="Create Account"
                loading={isSubmitting}
                disabled={isSubmitting || !termsAccepted || !!successMessage}
                loadingLabel="Creating..."
                className={`w-full !bg-blue-800 mt-4 text-white font-medium py-2 px-4 rounded-lg ${!termsAccepted ? '!bg-opacity-50 !cursor-not-allowed' : ''}`}
            />

            <p className="text-center text-gray-600">
                Already have an account?{' '}
                <CustomLink to="/" className="text-blue-600 hover:underline">
                    Login
                </CustomLink>
            </p>
        </form>
    );
};

export default Form;